<div class="wx metar">
  <div *ngIf="translated; else raw" class="wx__translated">
    <div class="wx__header">
      <div class="wx__header-field">
        <div class="wx__station">
          <div class="wx__station-text">{{ metar.stationId }}</div>
          <div *ngIf="distance !== null && direction" class="wx__distance">
            {{ distance | number: '1.0-0' }} nm {{ direction }}
          </div>
        </div>
        <app-flight-category [flightCategory]="metar.flightCategory" class="wx__flight-category"></app-flight-category>
      </div>
      <div class="wx__header-field">
        <div class="wx__header-field wx__field wx__issue-time-field">
          <div class="wx__field-label">Obsv:</div>
          <div class="wx__field-value">
            <div class="wx__issue-time">{{ issueTimeLocal }}</div>
            <div class="wx__issue-time-ago">({{ metar.observationTime | amTimeAgo }})</div>
          </div>
        </div>
      </div>
    </div>
    <div class="wx__body">
      <div class="wx__section">
        <div class="wx__section-body">
          <div class="wx__field">
            <div class="wx__field-label">Vis:</div>
            <div class="wx__field-value">
              <ng-container *ngIf="metar.visibility; else na">
                <span class="wx__value" [innerHTML]="metar.visibility"></span>
                <span class="wx__unit">SM</span>
              </ng-container>
            </div>
          </div>
          <div class="wx__field">
            <div class="wx__field-label">Wind:</div>
            <div class="wx__field-value">
              <app-wind *ngIf="metar.wind; else na" [wind]="metar.wind"></app-wind>
            </div>
          </div>
          <div class="wx__field">
            <div class="wx__field-label">Wx:</div>
            <div class="wx__field-value">
              <span *ngIf="metar.wxStringTrans; else na" [innerHTML]="metar.wxStringTrans" class="wx__wx"></span>
            </div>
          </div>
          <div class="wx__field">
            <div class="wx__field-label">Altm:</div>
            <div class="wx__field-value">
              <ng-container *ngIf="metar.altimeter; else na">
                <span class="wx__value">{{ metar.altimeter | number: '1.2-2' }}</span>
                <span class="wx__unit">"Hg</span>
              </ng-container>
            </div>
          </div>
          <div class="wx__field">
            <div class="wx__field-label">Temp:</div>
            <div class="wx__field-value">
              <span *ngIf="isNumeric(metar.temperature); else na">
                <span class="wx__value">{{ metar.temperature | number: '1.1-1' }}</span>
                <span class="wx__unit">&deg;C</span>
                <span class="wx__secondary">
                  (<span class="">{{ metar.temperature | convert: CELSIUS: FAHRENHEIT | number: '1.1-1' }}</span>
                  <span class="wx__unit">&deg;F</span>)
                </span>
              </span>
            </div>
          </div>
          <div class="wx__field">
            <div class="wx__field-label">Dew Pt:</div>
            <div class="wx__field-value">
              <span *ngIf="isNumeric(metar.dewpoint); else na">
                <span class="wx__value">{{ metar.dewpoint | number: '1.1-1' }}</span>
                <span class="wx__unit">&deg;C</span>
                <span class="wx__secondary">
                  (<span class="">{{ metar.dewpoint | convert: CELSIUS: FAHRENHEIT | number: '1.1-1' }}</span>
                  <span class="wx__unit">&deg;F</span>)
                </span>
              </span>
            </div>
          </div>
          <div class="wx__field wx__field--full-width">
            <div class="wx__field-label">Cld:</div>
            <div class="wx__field-value">
              <app-sky-conditions *ngIf="metar.skyConditions && metar.skyConditions.length > 0; else na"
                                  [skyConditions]="metar.skyConditions"></app-sky-conditions>
            </div>
          </div>
          <a href="https://www.aopa.org/weather/?a={{ metar.stationId }}" target="_blank">See more details in AOPA weather</a>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #raw>
  <div class="wx__raw">
    <app-wx-icon [flightCategory]="metar.flightCategory" class="wx__raw-icon"></app-wx-icon>
    <span class="wx__raw-text" [innerHTML]="metar.rawText"></span>
  </div>
  <a href="https://www.aopa.org/weather/?a={{ metar.stationId }}" target="_blank">See more details in AOPA weather</a>
</ng-template>
<ng-template #na>
  <span class="wx__na">N/A</span>
</ng-template>
